{
  "name": "Cash on Delivery",
  "description": "Pay in cash when your order is delivered",
  "eligibility": {
    "eligible": "Cash on Delivery available",
    "not_eligible": "Cash on Delivery not available",
    "min_amount": "Minimum amount: {{amount}} FCFA",
    "max_amount": "Maximum amount: {{amount}} FCFA",
    "zone_restricted": "Not available in your delivery zone",
    "max_pending": "You have reached the maximum number of pending orders"
  },
  "verification": {
    "title": "Phone verification",
    "subtitle": "A verification code will be sent via SMS",
    "enter_code": "Enter the code received by SMS",
    "resend": "Resend code",
    "resend_countdown": "Resend in {{seconds}}s",
    "verified": "Phone verified",
    "invalid_code": "Invalid code",
    "expired": "Code expired, please request a new one"
  },
  "confirmation": {
    "title": "Order confirmed — Cash on Delivery",
    "amount_due": "Amount due: {{amount}} FCFA",
    "instructions": "Prepare the exact amount for the delivery agent",
    "no_change": "The delivery agent does not provide change"
  },
  "admin": {
    "title": "Cash on Delivery settings",
    "enabled": "Enable Cash on Delivery",
    "min_amount": "Minimum amount (FCFA)",
    "max_amount": "Maximum amount (FCFA)",
    "zones": "Allowed zones",
    "phone_verification": "Require phone verification",
    "max_pending": "Max pending orders per customer",
    "save": "Save"
  }
}
